module.exports = __webpack_public_path__ + "img/syukyaku-top-005.6cc5e977.jpg";